import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CreditorsService} from '../services/creditors.service';
import {OrdersService} from '../services/orders.service';
import {OrderLine} from '../services/order-line';

@Component({
    selector: 'app-order-line-sourcing-modal',
    templateUrl: './order-line-sourcing-modal.component.html',
    styleUrls: ['./order-line-sourcing-modal.component.scss'],
    providers: [CreditorsService, OrdersService]
})
export class OrderLineSourcingModalComponent implements OnInit {

    public orderLine: OrderLine;

    constructor(
        public activeModal: NgbActiveModal,
        public creditorsService: CreditorsService,
        public ordersService: OrdersService) {
    }

    ngOnInit(): void {
    }

    close(): void {
        this.activeModal.dismiss();
    }
}
